import { h, Component } from 'preact';
import Helmet from 'react-helmet';
import Carousel from 'q-mdc/quikr/core/quikrCarousel';
import PartnershipForm from './form';
import QuikrLogo from './quikrLogo';
import { isMobileRequest } from './../../../utils/CommonHelper';
import "./index.scss";

class PartnershipListing extends Component {
    constructor(props) {
        super(props);
        const d = new Date();
        this.Year = d.getFullYear();
    }
    getMetaTags = () => {
        const { data: { metaDescription } } = this.props;
        let tags = [{ "name": "description","content": metaDescription }];
        tags.push({ "name": "robots", "content": "noindex, nofollow"});
        tags.push({ "name": "googlebot", "content": "noindex, nofollow"});
        return tags;
    }
    render(props){
        if(props.data) {
            const banners = isMobileRequest() ? props.data.mobileImages : props.data.desktopImages;
            return(
                <div class="bmw--wrapper">
                    <Helmet title={props.data.seoTitle} meta={this.getMetaTags()}></Helmet>
                    <header class="bmw-header">
                        <QuikrLogo />
                        <img src={props.data.logo} alt="" class="bmwlogo" />
                    </header>
                    {banners.length > 1 ? <Carousel
                        items={banners.map((banner, index) => ( <img draggable={true} src={banner.imageUrl} /> ))}
                        slidesToShow={1}
                        slidesToScroll={1}
                        infiniteScrolling
                        autoPlay={true}
                        dots={true}
                        centerMode={false}
                        fixedWidth={false}
                        /> : <img class="qc-partnerhip__img" src={banners[0].imageUrl} alt="" />
                    }
                    <div class="bmw__content">
                        <PartnershipForm formData={props.data} />
                    </div>
                    <footer>
                        Copyright &copy; 2008-{this.Year} Quikr India Private Limited
                    </footer>
                </div>
            )
        }
    }
}
export default PartnershipListing


// WEBPACK FOOTER //
// ../q-cars/src/components/common/Partnerships/index.js